import React from 'react';

export const PauseFilled = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M5 19.5v-15C5 3.5 5.5 3 6.5 3h2c1 0 1.5.5 1.5 1.5v15c0 1-.5 1.5-1.5 1.5h-2c-1 0-1.5-.5-1.5-1.5ZM15.5 21h2c1 0 1.5-.5 1.5-1.5v-15c0-1-.5-1.5-1.5-1.5h-2c-1 0-1.5.5-1.5 1.5v15c0 1 .5 1.5 1.5 1.5Z"
      />
    </svg>
  );
};
